import Navbar from '../components/Navbar';
import SocialLinks from '../components/SocialLinks';
import Settings from '../components/Settings';
import { motion } from 'framer-motion';
import SmallNavbar from '../components/SmallNavbar';
import WorkSlider from '../components/WorkSlider';
import { favicon } from '../constants';


const WorkPage = ({title, icon}) => {
  document.title = title;
  document.querySelector('link[rel="icon"]').href = favicon(icon);
  return (
    <motion.div 
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Navbar />
      <WorkSlider />
      <SocialLinks />
      <SmallNavbar />
      <Settings />
    </motion.div>
  )
}

export default WorkPage;
